// ── Grade range config ────────────────────────────────────────────────────────
// Maps the 4 display ranges to their API school_grade IDs
// IDs come from GET /school-grade endpoint
export interface GradeConfig {
  id: string;                  // display key used throughout the app
  label: string;               // shown in UI
  school_grade_from_id: number;
  school_grade_to_id: number;
}

export const GRADE_CONFIG: GradeConfig[] = [
  // { id: 'k-2',   label: 'Kindergarten - 2nd Grade', school_grade_from_id: 1,  school_grade_to_id: 3  },
  { id: '3-5',   label: '3rd - 5th Grade',           school_grade_from_id: 4,  school_grade_to_id: 6  },
  { id: '6-8',   label: '6th - 8th Grade',           school_grade_from_id: 7,  school_grade_to_id: 9  },
  // { id: '9-10',  label: '9th - 10th Grade',          school_grade_from_id: 10, school_grade_to_id: 11 },
  // { id: '11-12', label: '11th - 12th Grade',         school_grade_from_id: 12, school_grade_to_id: 13 },
];

export function getGradeConfig(gradeId: string): GradeConfig {
  return GRADE_CONFIG.find(g => g.id === gradeId) ?? GRADE_CONFIG[1];
}
